// import React, { useState, useEffect } from "react";
// import Sidebar from "../../Components/Sidebar";
// import TopNav from "../../Components/TopNav";
// import {
//   getSchemeConfigServ,
//   setSchemeConfigServ,
//   updateSchemeConfigServ,
//   deleteSchemeConfigServ,
// } from "../../services/schemeConfig.services";
// import { toast } from "react-toastify";
// import moment from "moment";

// function Scheme() {
//   const [schemeConfig, setSchemeConfig] = useState(null);
//   const [formData, setFormData] = useState({
//     schemeStartMonth: "",
//     schemeEndMonth: "",
//   });
//   const [isLoading, setIsLoading] = useState(false);

//   const fetchSchemeConfig = async () => {
//     try {
//       const res = await getSchemeConfigServ();
//       if (res?.data?.statusCode === 200) {
//         setSchemeConfig(res.data.data);
//         setFormData({
//           schemeStartMonth: moment(res.data.data.schemeStartDate).format("YYYY-MM"),
//           schemeEndMonth: moment(res.data.data.schemeEndDate).format("YYYY-MM"),
//         });
//       }
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.message || "Failed to fetch scheme config"
//       );
//     }
//   };

//   useEffect(() => {
//     fetchSchemeConfig();
//   }, []);

//   const handleSubmit = async () => {
//     setIsLoading(true);
//     try {
//       // Convert "YYYY-MM" to Date by adding "-01"
//       const submitData = {
//         schemeStartDate: new Date(formData.schemeStartMonth + "-01"),
//         schemeEndDate: new Date(formData.schemeEndMonth + "-01"),
//       };

//       let res;
//       if (schemeConfig?._id) {
//         res = await updateSchemeConfigServ(schemeConfig._id, submitData);
//       } else {
//         res = await setSchemeConfigServ(submitData);
//       }
//       if (res?.data?.statusCode === 200) {
//         toast.success(res.data.message);
//         fetchSchemeConfig();
//       }
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.message || "Failed to save scheme config"
//       );
//     }
//     setIsLoading(false);
//   };

//   const handleDelete = async () => {
//     const confirmed = window.confirm(
//       "Are you sure you want to delete scheme config?"
//     );
//     if (confirmed) {
//       try {
//         const res = await deleteSchemeConfigServ(schemeConfig._id);
//         if (res?.data?.statusCode === 200) {
//           toast.success(res.data.message);
//           setSchemeConfig(null);
//           setFormData({
//             schemeStartMonth: "",
//             schemeEndMonth: "",
//           });
//         }
//       } catch (error) {
//         toast.error(
//           error?.response?.data?.message || "Failed to delete scheme config"
//         );
//       }
//     }
//   };

//   return (
//     <div className="bodyContainer">
//       <Sidebar selectedMenu="Subscription" selectedItem="Scheme" />
//       <div className="mainContainer">
//         <TopNav />
//         <div className="p-lg-4 p-md-3 p-2">
//           <div className="row mx-0 p-0">
//             <div className="col-12">
//               <h3 className="mb-4 text-bold text-secondary">Scheme Config</h3>

//               <div className="card p-4 shadow-sm" style={{ maxWidth: "500px" }}>
//                 <label>Scheme Start Month</label>
//                 <input
//                   className="form-control mb-3 border-primary shadow-sm"
//                   type="month"
//                   value={formData.schemeStartMonth}
//                   onChange={(e) =>
//                     setFormData({
//                       ...formData,
//                       schemeStartMonth: e.target.value,
//                     })
//                   }
//                   style={{ fontWeight: "500" }}
//                 />

//                 <label>Scheme End Month</label>
//                 <input
//                   className="form-control mb-3 border-primary shadow-sm"
//                   type="month"
//                   value={formData.schemeEndMonth}
//                   onChange={(e) =>
//                     setFormData({
//                       ...formData,
//                       schemeEndMonth: e.target.value,
//                     })
//                   }
//                   style={{ fontWeight: "500" }}
//                 />

//                 <button
//                   className="btn btn-success w-100 mb-2"
//                   onClick={handleSubmit}
//                   disabled={
//                     !formData.schemeStartMonth ||
//                     !formData.schemeEndMonth ||
//                     isLoading
//                   }
//                 >
//                   {isLoading
//                     ? "Saving..."
//                     : schemeConfig
//                     ? "Update Scheme Config"
//                     : "Set Scheme Config"}
//                 </button>

//                 {schemeConfig && (
//                   <button
//                     className="btn btn-danger w-100"
//                     onClick={handleDelete}
//                   >
//                     Delete Scheme Config
//                   </button>
//                 )}
//               </div>

//               {schemeConfig && (
//                 <div className="mt-4">
//                   <h5>Current Scheme Config:</h5>
//                   <p>
//                     <strong>Start Month:</strong>{" "}
//                     {moment(schemeConfig.schemeStartDate).format("MMMM YYYY")}
//                   </p>
//                   <p>
//                     <strong>End Month:</strong>{" "}
//                     {moment(schemeConfig.schemeEndDate).format("MMMM YYYY")}
//                   </p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Scheme;


import React, { useState, useEffect } from "react";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import {
  getSchemeConfigServ,
  setSchemeConfigServ,
  updateSchemeConfigServ,
  deleteSchemeConfigServ,
} from "../../services/schemeConfig.services";
import { toast } from "react-toastify";
import moment from "moment";

/* ─── Scoped Styles ───────────────────────── */
const styles = `
  .scheme-page {
    background: #f5f5f7;
    min-height: 100%;
    padding: 28px;
    font-family: 'Segoe UI', sans-serif;
  }

  .scheme-grid {
    display: grid;
    grid-template-columns: 1fr 360px;
    gap: 20px;
    align-items: start;
  }

  @media (max-width: 992px) {
    .scheme-grid {
      grid-template-columns: 1fr;
    }
  }

  .scheme-card {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #f0eded;
    overflow: hidden;
  }

  .scheme-card-header {
    padding: 20px 24px;
    border-bottom: 1px solid #f7f5f5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
  }

  .scheme-title-wrap {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  .scheme-icon {
    width: 52px;
    height: 52px;
    border-radius: 14px;
    background: #fdf2f1;
    color: #a60808;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    flex-shrink: 0;
  }

  .scheme-title {
    font-size: 19px;
    font-weight: 700;
    color: #1c0a0a;
    margin-bottom: 4px;
  }

  .scheme-subtitle {
    font-size: 14px;
    color: #999;
  }

  .scheme-status {
    padding: 7px 14px;
    border-radius: 30px;
    background: #eaf3de;
    color: #3b6d11;
    font-size: 13px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .scheme-body {
    padding: 24px;
  }

  .scheme-form-group {
    margin-bottom: 22px;
  }

  .scheme-label {
    display: block;
    margin-bottom: 9px;
    font-size: 14px;
    font-weight: 600;
    color: #444;
  }

  .scheme-input-wrap {
    position: relative;
  }

  .scheme-input-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #a60808;
    font-size: 16px;
  }

  .scheme-input {
    width: 100%;
    height: 50px;
    border-radius: 12px;
    border: 1px solid #f0eded;
    background: #fafafa;
    padding: 0 16px 0 44px;
    font-size: 14px;
    color: #444;
    outline: none;
    transition: all 0.18s ease;
  }

  .scheme-input:focus {
    border-color: #f0c0b8;
    background: #fff;
  }

  .scheme-btn-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin-top: 28px;
  }

  .scheme-primary-btn {
    height: 46px;
    padding: 0 22px;
    border: none;
    border-radius: 12px;
    background: #a60808;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.18s ease;
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  .scheme-primary-btn:hover:not(:disabled) {
    background: #a93226;
  }

  .scheme-primary-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .scheme-danger-btn {
    height: 46px;
    padding: 0 22px;
    border-radius: 12px;
    border: 1px solid #fcc;
    background: #fff;
    color: #a60808;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.18s ease;
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  .scheme-danger-btn:hover {
    background: #fdf2f1;
  }

  .scheme-info-card {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #f0eded;
    padding: 22px;
  }

  .scheme-info-title {
    font-size: 18px;
    font-weight: 700;
    color: #1c0a0a;
    margin-bottom: 20px;
  }

  .scheme-info-item {
    padding: 16px;
    border-radius: 14px;
    background: #fafafa;
    border: 1px solid #f5f3f3;
    margin-bottom: 14px;
  }

  .scheme-info-label {
    font-size: 13px;
    color: #999;
    margin-bottom: 6px;
  }

  .scheme-info-value {
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }

  .scheme-empty {
    padding: 18px;
    border-radius: 14px;
    background: #fdf2f1;
    color: #a93226;
    font-size: 14px;
    border: 1px dashed #f0c0b8;
  }
`;

function Scheme() {
  const [schemeConfig, setSchemeConfig] = useState(null);

  const [formData, setFormData] = useState({
    schemeStartMonth: "",
    schemeEndMonth: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const fetchSchemeConfig = async () => {
    try {
      const res = await getSchemeConfigServ();

      if (res?.data?.statusCode === 200) {
        setSchemeConfig(res.data.data);

        setFormData({
          schemeStartMonth: moment(
            res.data.data.schemeStartDate
          ).format("YYYY-MM"),

          schemeEndMonth: moment(
            res.data.data.schemeEndDate
          ).format("YYYY-MM"),
        });
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Failed to fetch scheme config"
      );
    }
  };

  useEffect(() => {
    fetchSchemeConfig();
  }, []);

  const handleSubmit = async () => {
    setIsLoading(true);

    try {
      const submitData = {
        schemeStartDate: new Date(
          formData.schemeStartMonth + "-01"
        ),

        schemeEndDate: new Date(
          formData.schemeEndMonth + "-01"
        ),
      };

      let res;

      if (schemeConfig?._id) {
        res = await updateSchemeConfigServ(
          schemeConfig._id,
          submitData
        );
      } else {
        res = await setSchemeConfigServ(submitData);
      }

      if (res?.data?.statusCode === 200) {
        toast.success(res.data.message);
        fetchSchemeConfig();
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Failed to save scheme config"
      );
    }

    setIsLoading(false);
  };

  const handleDelete = async () => {
    const confirmed = window.confirm(
      "Are you sure you want to delete scheme config?"
    );

    if (confirmed) {
      try {
        const res = await deleteSchemeConfigServ(
          schemeConfig._id
        );

        if (res?.data?.statusCode === 200) {
          toast.success(res.data.message);

          setSchemeConfig(null);

          setFormData({
            schemeStartMonth: "",
            schemeEndMonth: "",
          });
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.message ||
            "Failed to delete scheme config"
        );
      }
    }
  };

  return (
    <div className="bodyContainer">
      <style>{styles}</style>

      <Sidebar
        selectedMenu="Subscription"
        selectedItem="Scheme"
      />

      <div className="mainContainer">
        <TopNav
          pageTitle="Scheme Config"
          pagePath="Home / Subscription / Scheme"
        />

        <div className="scheme-page">
          <div className="scheme-grid">

            {/* ── Main Card ── */}
            <div className="scheme-card">

              <div className="scheme-card-header">
                <div className="scheme-title-wrap">
                  <div className="scheme-icon">
                    <i className="ti ti-calendar-event" />
                  </div>

                  <div>
                    <div className="scheme-title">
                      Scheme Configuration
                    </div>

                    <div className="scheme-subtitle">
                      Configure subscription scheme duration
                    </div>
                  </div>
                </div>

                {schemeConfig && (
                  <div className="scheme-status">
                    <i className="ti ti-circle-check" />
                    Active
                  </div>
                )}
              </div>

              <div className="scheme-body">

                {/* Start Month */}
                <div className="scheme-form-group">
                  <label className="scheme-label">
                    Scheme Start Month
                  </label>

                  <div className="scheme-input-wrap">
                    <i className="ti ti-calendar scheme-input-icon" />

                    <input
                      className="scheme-input"
                      type="month"
                      value={formData.schemeStartMonth}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          schemeStartMonth: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                {/* End Month */}
                <div className="scheme-form-group">
                  <label className="scheme-label">
                    Scheme End Month
                  </label>

                  <div className="scheme-input-wrap">
                    <i className="ti ti-calendar-month scheme-input-icon" />

                    <input
                      className="scheme-input"
                      type="month"
                      value={formData.schemeEndMonth}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          schemeEndMonth: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                {/* Buttons */}
                <div className="scheme-btn-row">

                  <button
                    className="scheme-primary-btn"
                    onClick={handleSubmit}
                    disabled={
                      !formData.schemeStartMonth ||
                      !formData.schemeEndMonth ||
                      isLoading
                    }
                  >
                    <i className="ti ti-device-floppy" />

                    {isLoading
                      ? "Saving..."
                      : schemeConfig
                      ? "Update Scheme Config"
                      : "Set Scheme Config"}
                  </button>

                  {schemeConfig && (
                    <button
                      className="scheme-danger-btn"
                      onClick={handleDelete}
                    >
                      <i className="ti ti-trash" />
                      Delete Config
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* ── Info Card ── */}
            <div className="scheme-info-card">

              <div className="scheme-info-title">
                Current Configuration
              </div>

              {schemeConfig ? (
                <>
                  <div className="scheme-info-item">
                    <div className="scheme-info-label">
                      Start Month
                    </div>

                    <div className="scheme-info-value">
                      {moment(
                        schemeConfig.schemeStartDate
                      ).format("MMMM YYYY")}
                    </div>
                  </div>

                  <div className="scheme-info-item">
                    <div className="scheme-info-label">
                      End Month
                    </div>

                    <div className="scheme-info-value">
                      {moment(
                        schemeConfig.schemeEndDate
                      ).format("MMMM YYYY")}
                    </div>
                  </div>
                </>
              ) : (
                <div className="scheme-empty">
                  No scheme configuration found.
                </div>
              )}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default Scheme;